<template lang="html">
  <div class="language row-center ais">
    <div class="flags" v-for="oLang in languages" v-if="oLang != $i18n.locale">
      <router-link class="lang" :to="{ name: $route.name, params: { lang: oLang } }">
        <span>{{ oLang }}</span>
      </router-link>
    </div>
  </div>
</template>

<script lang="js">
import messages from '@/translations';

export default {
  name: 'idioma',
  props: ['show'],
  data() {
    return {
      oldLang: '',
      languages: Object.keys(messages),
    }
  }
}
</script>

<style scoped>
.language .flags .lang {
  display: block;
  position: relative;
  max-width: 40px;
  padding: 0 10px;
  border-left: 1px solid white;
}

.language .flags:first-child .lang {
  border-left: none;
}

.language .lang span {
  color: white;
  text-transform: uppercase;
}

.language .lang:hover span {
  opacity: 1;
}



.bandera {
  max-width: 60px;
  width: 100%;
  display: block;
  border: 1px solid #000;
}

.language .cerrar {
  font-size: 40px;
}

.flags {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-align-items: center;
  align-items: center;
}


@media screen and (max-width:370px) {
  .language .lang {
    padding: 0 5px;
  }

  .language .lang span {
    font-size: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/view-parts/footer-parts/idioma.vue